module.exports = __webpack_public_path__ + "media/images/card-tickets02-b59bfa05284265404c9cde53860a546f.svg";